import React from "react";
import {connect} from "react-redux";
import {logout} from "../../../../redux/actions/auth/loginActions";
import {
    BrowserView, isMobile,
    MobileView,
} from "react-device-detect";
import Menu from "./Menu"
import * as Icon from "react-feather";
import {ListGroup} from 'react-bootstrap';
import MobileNavbar from "./MobileMenuRender/Navbar";
import {GetRequest} from "../../../request";
import Notify from "components/Baran/noty/notify";
import {history} from "../../../../history";
import {Link, NavLink} from "react-router-dom";
import {Roles} from "../../../roles/ProjectRole";
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {ContextLayout} from "../../../../layouts/PageLayout";
import {HiOutlineUser} from 'react-icons/hi'
import logoImage from '../../../../assets/img/logo/logo.webp'
import logoLight from '../../../../assets/img/logo/logoLight.webp'
import {AiFillHome, AiOutlineArrowUp, AiOutlineFileDone} from 'react-icons/ai'
import scrollWindowTop from "../../../../utility/scrollWindowTop";
import {RiSearch2Line} from "react-icons/ri"
import {
    Phone,
} from "react-feather";
import data from "../../../../assets/data/configs/storeConfig.json";
import {BiSearchAlt} from "react-icons/bi";
import {IoPhonePortraitOutline} from "react-icons/io5";
import "./style.scss"

let searchDelay = 0;

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            doesShowSearchBar: false,
            searchValue: "",
            position: 0,
            modal: false,
            searchUrl: "/api/home/web/search",
            courses: [],
            course_categories: [],
            articles: [],
            article_categories: [],
            searchBox: false,
            dropdownUser: false,
            support: false,
            modal_download: false,
            mobileClick: false,
            scrolled: false,
        }
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        if (window.scrollY > 50) {
            this.setState({scrolled: true});
        } else {
            this.setState({scrolled: false});
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.state.position) {
            const listenToScroll = () => {
                const winScroll =
                    document.body.scrollTop || document.documentElement.scrollTop

                const height =
                    document.documentElement.scrollHeight -
                    document.documentElement.clientHeight

                const scrolled = winScroll / height

                this.setState(scrolled)
            }
            window.addEventListener('scroll', listenToScroll)
            return () => window.removeEventListener('scroll', listenToScroll);
        }

    }

    getData = () => {
        GetRequest(`${this.state.searchUrl}?s=${this.state.searchValue}`,
            {
                'Authorization': this.props.user.token,
            }, true).then((response) => {
            let result = response.data;
            if (result.ok) {
                result = result.data;
                this.setState({
                    courses: result.courses,
                    course_categories: result.course_categories,
                    articles: result.articles,
                    article_categories: result.article_categories
                })
            }
        }).catch(function (error) {
            Notify('error', 'top-right', "خطایی رخ داده است");
        });
    }

    showSearchBar = () => {
        this.setState({
            doesShowSearchBar: !this.state.doesShowSearchBar
        })
    }

    searchHandler = (e) => {
        clearTimeout(searchDelay)
        this.setState({
            searchValue: e.target.value,
            closeList: false
        })
        if (this.state.searchValue.length > 0) {
            searchDelay = setTimeout(async () => {
                this.getData();
            }, 800);
        }
    }

    openSearchBox = () => {
        this.setState({
            searchBox: !this.state.searchBox,
        })
    }
    handleSearchClick = () => {
        history.push("/courses?s=" + this.state.searchValue);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            history.push("/courses?s=" + this.state.searchValue);
        }
    }

    closeResults = () => {
        this.setState({
            closeList: !this.state.closeList,
        })
    }

    goToPanel = () => {
        if (this.props.user.roles.includes(Roles.Student))
            history.push('/panel/my-courses')
        else if (this.props.user.roles.includes(Roles.Teacher))
            history.push('/panel/teacher-courses')
        else
            history.push('/panel/dashboard')
    }

    exit = () => {
        if (this.props.user.token)
            this.props.logout()
    }


    render() {
        const searchbar =
            <>
                {
                    <div className="d-flex search-field">
                        {this.state.searchValue ?
                            <ListGroup className={this.state.closeList ? "d-none" : "search-results"}
                                       onMouseLeave={() => this.closeResults()}>
                                {this.state.courses.length > 0 ?
                                    <>
                                        <label className="d-flex justify-content-between">
                                            <span>دوره</span>
                                            <NavLink to={"/search?s=" + this.state.searchValue}
                                                     className="bg-transparent border-0">مشاهده بیشتر</NavLink>
                                        </label>
                                        {this.state.courses.map((item, index) => {
                                                return (
                                                    <ListGroup.Item
                                                        className={`w-100 ${this.state.course_categories.length - 1 === index && "border-b"}`}>
                                                        <NavLink to={"/course/" + item.slug} className="w-100 d-block"
                                                                 key={item.course_id}>
                                                            <div className="d-flex align-items-flex">
                                                                <div className="image-wrapper">
                                                                    <img
                                                                        src={item.image}
                                                                        alt={item.name}
                                                                        title={item.name}/>
                                                                </div>
                                                                <span
                                                                    className="my-auto ml-1">{item.name}</span>
                                                            </div>
                                                        </NavLink>
                                                    </ListGroup.Item>
                                                )
                                            }
                                        )}
                                    </> : null
                                }
                                {this.state.articles.length > 0 ?
                                    <>
                                        <label className="d-flex justify-content-between">
                                            <span>مقاله ها</span>
                                            <NavLink to={"/search?s=" + this.state.searchValue}
                                                     className="bg-transparent border-0">مشاهده بیشتر</NavLink>
                                        </label>
                                        {this.state.articles.map((item, index) => {
                                                return (
                                                    <ListGroup.Item
                                                        className={`w-100 ${this.state.course_categories.length - 1 === index && "border-b"}`}>
                                                        <NavLink to={"/article/" + item.slug} className="w-100 d-block"
                                                                 key={item.article_id}>
                                                            <div className="d-flex align-items-flex">
                                                                <div className="image-wrapper">
                                                                    <img
                                                                        src={item.image}
                                                                        alt={item.title}
                                                                        title={item.title}/>
                                                                </div>
                                                                <span
                                                                    className="my-auto ml-1">{item.title}</span>
                                                            </div>
                                                        </NavLink>
                                                    </ListGroup.Item>
                                                )
                                            }
                                        )}
                                    </> : null
                                }
                            </ListGroup> : null
                        }
                    </div>
                }
            </>

        const search =
            <div
                className={`header-template-two-left-search-box ${this.state.searchBox && "header-template-two-left-search-box-open"}`}>
                <input
                    className="search-box"
                    type="text"
                    placeholder="جستجو..."
                    onKeyDown={this.handleKeyDown}
                    onMouseEnter={() => this.closeResults()}
                    onChange={(e) => this.searchHandler(e)}
                    aria-label="Input group example"
                    aria-describedby="btnGroupAddon2"
                />
            </div>;


        const login = this.props.user.token ?
            <div className="header-template-two-left-login">
                <ul className="nav navbar-nav navbar-nav-user w-100" onClick={() => isMobile && this.goToPanel()}>
                    <UncontrolledDropdown tag="li"
                                          className="dropdown-user nav-item text-center">
                        <DropdownToggle tag="a"
                                        className="nav-link dropdown-user-link">
                            <div className="user-nav d-sm-flex d-none">
                            </div>
                            <span data-tour="user">
                                                      <img
                                                          src={this.props.user.photo}
                                                          className="round"
                                                          height="40"
                                                          width="40"
                                                          alt="avatar"
                                                      />
                                                    </span>
                            {" "}
                            حساب کاربری
                        </DropdownToggle>
                        <DropdownMenu left>
                            <DropdownItem
                                tag="a"
                                href="#"
                                onClick={this.goToPanel}>
                                <Icon.User size={14} className="ml-50"/>
                                <span className="align-middle">
                                                            پنل
                                                        </span>
                            </DropdownItem>
                            <DropdownItem divider/>
                            <DropdownItem
                                tag="a"
                                onClick={this.exit}>
                                <Icon.Power size={14} className="ml-50"/>
                                <span className="align-middle">
                                                            <FormattedMessage id="Logout"/>
                                                        </span>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </ul>
            </div>
            :
            <ContextLayout.Consumer>
                {context => {
                    return (
                        <div className="header-template-two-left-login" onClick={() => context.showLoginModal(true)}>
                            <div className="header-template-two-left-login-button">
                                <HiOutlineUser size={25}/>
                                {" "}
                                ورود / ثبت نام
                            </div>
                        </div>
                    )
                }
                }
            </ContextLayout.Consumer>

        let Moderate = false;

        if (this.props.user.roles)
            Moderate = this.props.user.roles.includes(Roles.Moderate);

        /*        <BrowserView>
                    <div className="header-web w-100">
                        <div className="header">

                            <div className="down-header  d-flex justify-content-between mx-0">
                                <div className='header-menu position-relative '>
                                    <div className=''>
                                        <div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </BrowserView>

                */

        const logo = window.location.pathname === "/" ? this.state.scrolled ? logoImage : logoImage : logoImage
        return (
            <>
                <div
                    className={window.location.pathname === "/" ? this.state.scrolled ? "header-position-fixed bg-white" : "header-position-fixed" : "header-position-sticky bg-white"}
                    theme={window.location.pathname === "/" ? this.state.scrolled ? "light" : "transparent" : "light"}>
                    <BrowserView>
                        <div className="header-template-two">
                            <div className="header-template-two-right w-70">
                                <div className='header-template-two-right-logo'>
                                    <Link to={"/"}>
                                        <img src={logo} width={120}/>
                                    </Link>
                                </div>
                                <div className="header-template-two-right-menu w-100">
                                    <Menu/>
                                </div>
                            </div>
                            <div className="header-template-two-left">
                                <div className={`header-template-two-left-search`} onClick={this.openSearchBox}>
                                    <BiSearchAlt size={25}/>
                                </div>

                                {login}
                                <a href={`tel:${data.mobile[0]?.value}`} className='header-template-two-left-phone'>
                                    <Phone size={20}/>
                                    <span>{data.mobile[0]?.value}</span>
                                </a>
                            </div>
                        </div>
                    </BrowserView>
                    <MobileView>
                        <div className='header-template-two-phone'>
                            <div className="">
                                <MobileNavbar
                                    logo={
                                        logoImage
                                    }
                                    search={
                                        searchbar
                                    }
                                />
                            </div>
                            <div className='header-logo'>
                                <Link to={"/"}>
                                    <img src={
                                        logo
                                    } width={100}/>
                                </Link>
                            </div>
                            <div>
                                <div className={`header-template-two-left-search`} onClick={this.openSearchBox}>
                                    <BiSearchAlt size={25}/>
                                </div>
                            </div>
                        </div>
                    </MobileView>
                    {
                        search
                    }
                </div>
                <MobileView>
                    <div className='bottom-menu-template-one'>
                        <Link to={"/"}
                              className={`bottom-menu-template-one-item ${window.location.pathname === "/" && "bottom-menu-template-one-item-active"}`}
                        >
                            <AiFillHome/>
                            <p>صفحه اصلی </p>
                        </Link>

                        <ContextLayout.Consumer>
                        {
                            context => {
                                return <div className={`bottom-menu-template-one-item`}
                                            onClick={() => this.props.user.token ? this.goToPanel() : context.showLoginModal(true)}>

                                    {
                                        this.props.user.token ? <>
                                            <img
                                                src={this.props.user.photo}
                                                className="round"
                                                alt="avatar"
                                            />
                                            <p className={"font-weight-bolder"}> حساب کاربری </p>
                                        </> : <>
                                            <HiOutlineUser size={25}/>
                                            <p className={"font-weight-bolder"}> ورود / ثبت نام </p>
                                        </>
                                    }

                                </div>
                            }
                        }
                        </ContextLayout.Consumer>

                        <Link to='/courses'
                              className={`bottom-menu-template-one-item ${window.location.pathname === "/courses" && "bottom-menu-template-one-item-active"}`}
                        >
                            <span> <AiOutlineFileDone/></span>
                            <p>دوره ها</p>
                        </Link>
                        <Link to='/contact-us'
                              className={`bottom-menu-template-one-item ${window.location.pathname === "/contact-us" && "bottom-menu-template-one-item-active"}`}
                        >
                            <span> <IoPhonePortraitOutline/></span>
                            <p>ارتباط با ما</p>
                        </Link>

            {/*            <div className='scroll-to-top' onClick={scrollWindowTop}>
                            <a><AiOutlineArrowUp/></a>
                        </div>*/}
                    </div>
                </MobileView>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth,
        UI: state.UI
    }
}
export default connect(mapStateToProps, {
    logout
})(Header)
